/* Millesève — barre d'achat collante sur mobile (E3.6, DS §10.6, sections/main-product.liquid).
   La barre n'a pas de formulaire : son bouton envoie celui de la colonne d'achat (attribut form).
   - Suivi de la variante : on recopie le prix (#price-<section>) et l'état du bouton de la colonne
     (#ProductSubmitButton-<section> : désactivé, « Épuisé », « Indisponible », « Ajouté ») par
     MutationObserver ; product-info.js les met à jour à chaque changement de format, même quand la
     variante n'existe pas (cas où il ne publie pas variantChange).
   - Quantité : 1 quand l'envoi vient de la barre (événement formdata, lu par product-form.js).
   - Apparition (moins de 750 px) : quand le bouton de la colonne est passé au-dessus de l'écran,
     et tant que le pied de page n'est pas visible. Le glissement suit --dur-fast (0 en mouvement réduit). */
if (!customElements.get('ms-barre-achat')) {
  customElements.define(
    'ms-barre-achat',
    class MsBarreAchat extends HTMLElement {
      connectedCallback() {
        const section = this.dataset.section;
        this.bouton = this.querySelector('.ms-barre__bouton');
        this.prix = this.querySelector('.ms-barre__prix');
        this.form = document.getElementById(this.bouton.getAttribute('form'));
        this.boutonColonne = document.getElementById(`ProductSubmitButton-${section}`);
        this.prixColonne = document.getElementById(`price-${section}`);
        if (!this.form || !this.boutonColonne) return;

        this.recopier = this.recopier.bind(this);
        this.recopier();
        this.miroir = new MutationObserver(this.recopier);
        this.miroir.observe(this.boutonColonne, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.prixColonne) {
          this.miroir.observe(this.prixColonne, {
            attributes: true,
            attributeFilter: ['class'],
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        // Quantité 1 pour un ajout depuis la barre : on marque l'envoi, product-form.js construit
        // ensuite son FormData (événement formdata), où l'on remplace la quantité.
        this.depuisBarre = false;
        this.onSubmit = (e) => {
          if (e.target === this.form) this.depuisBarre = e.submitter === this.bouton;
        };
        this.onFormData = (e) => {
          if (!this.depuisBarre) return;
          this.depuisBarre = false;
          e.formData.set('quantity', '1');
        };
        document.addEventListener('submit', this.onSubmit, true);
        this.form.addEventListener('formdata', this.onFormData);

        this.mobile = window.matchMedia('(max-width: 749px)');
        this.majVisibilite = this.majVisibilite.bind(this);
        // L'observateur ne sert que de déclencheur : la position est relue à chaque fois.
        this.cible = this.boutonColonne.closest('.product-form__buttons') || this.boutonColonne;
        this.pied = document.querySelector('.ms-pied, footer');
        this.guet = new IntersectionObserver(this.majVisibilite);
        this.guet.observe(this.cible);
        if (this.pied) this.guet.observe(this.pied);
        this.mobile.addEventListener('change', this.majVisibilite);
        this.majVisibilite();
      }

      disconnectedCallback() {
        this.miroir?.disconnect();
        this.guet?.disconnect();
        this.mobile?.removeEventListener('change', this.majVisibilite);
        if (this.onSubmit) document.removeEventListener('submit', this.onSubmit, true);
        this.form?.removeEventListener('formdata', this.onFormData);
      }

      majVisibilite() {
        const hauteur = window.innerHeight;
        const boutonPasse = this.cible.getBoundingClientRect().bottom <= 0;
        const rPied = this.pied?.getBoundingClientRect();
        const piedVisible = !!rPied && rPied.top < hauteur && rPied.bottom > 0;
        // Tant que le focus est dans la barre, elle reste affichée (CSS :focus-within).
        this.classList.toggle('is-visible', this.mobile.matches && boutonPasse && !piedVisible);
      }

      recopier() {
        const source = this.boutonColonne;
        this.bouton.disabled = source.disabled;
        if (source.getAttribute('aria-disabled') === 'true') this.bouton.setAttribute('aria-disabled', 'true');
        else this.bouton.removeAttribute('aria-disabled');
        const texteSource = source.querySelector('span')?.textContent.trim();
        const texte = this.bouton.querySelector('span');
        if (texteSource && texte && texte.textContent.trim() !== texteSource) texte.textContent = texteSource;

        if (this.prixColonne) {
          if (this.prix.innerHTML !== this.prixColonne.innerHTML) this.prix.innerHTML = this.prixColonne.innerHTML;
          this.prix.classList.toggle('hidden', this.prixColonne.classList.contains('hidden'));
        }
      }
    }
  );
}
